<template>
  <div>
    <label
      class="border bg-white rounded-lg d-flex justify-content-between cursor-pointer"
      style="color: #3f414d"
      :for="labelKey"
    >
      <div class="p-1 px-3 text-nowrap">
        <span v-if="files.length">({{ files.length }}) File Selected</span>
        <span v-else>No File Chosen</span>
      </div>
      <div class="p-1 px-2" style="background: #e9ecef">Browse</div>
    </label>
    <input
      type="file"
      style="display: none"
      :id="labelKey"
      multiple
      @change="onFileChange"
    />
  </div>
</template>

<script>
export default {
  name: 'InputFileMultiple',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    labelKey: {
      type: String,
      default: 'label-input-file-multiple',
    },
  },
  methods: {
    onFileChange(e) {
      this.$emit('change-files', Array.from(e.target.files))
    },
  },
}
</script>
